const FALLBACK = /^(\+)?[\d()[\]\- ]{0,25}$/;
const DELIMITED = /^\/(.+)\/([gimsuy]*)$/;

export const usePhoneRegex = () => {
  const globalStore = useGlobalStore();

  return computed(() => {
    const raw = String((globalStore.siteSettings as any)?.phone_number_validation_regex ?? "").trim();
    if (!raw) return FALLBACK;

    try {
      const match = DELIMITED.exec(raw);
      return match ? new RegExp(match[1], match[2]) : new RegExp(raw);
    } catch {
      return FALLBACK;
    }
  });
};
